import {isFunction} from "angular";

/**
 * Returnerer et objekt som inneholder et nytt Promise-objekt
 * og to funksjoner for å enten oppfylle eller avvise det.
 *
 * Tilsvarer Promise.withResolvers() - som per nov 2024 kun støttes av de seneste nettleserversjonene.
 * Se https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
export function promiseMedResolvere<T>(): PromiseMedResolvere<T> {
    let resolve!: PromiseMedResolvere<T>['resolve'], reject!: PromiseMedResolvere<T>['reject'];
    const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {promise, resolve, reject};
}

export interface PromiseMedResolvere<T> {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (årsak?: any) => void
}

export function timeoutSomPromise<T>(millisekunder: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, millisekunder);
    });
}

/** Sann dersom angitt verdi er et {@link Promise} */
export function erPromise(verdi: any): verdi is PromiseLike<any> {
    return isFunction(verdi?.then);
}

/** Returnerer angitt verdi pakket inn i et promise. Dersom angitt verdi allerede er et promise returneres dette uendret */
export function somPromise<T>(verdi: PotensieltPromise<T>): Promise<T> {
    return erPromise(verdi) ? verdi : Promise.resolve(verdi);
}

/** En verdi som potensielt er pakket inn i et Promise */
export type PotensieltPromise<T> = T | Promise<T>;
